import { useMutation } from "@tanstack/react-query";
import { useAuth } from "../../../../../Context/AuthContext";
import { getRCSReportSmryByPartners } from "../api/RCSSmryByPartners";

export const useRCSReportSmryByPartners = () => {
  const auth = useAuth();
  const user = auth.getSessionData();

  return useMutation({
    mutationKey: ["getRCSReportSmryByPartners"],
    mutationFn: async (data) => {
      return await getRCSReportSmryByPartners({
        token: user.token,
        data: {
          ...data,
          uid_partner: user?.uid_partner,
        },
      });
    },
  });
};
